import styled from 'styled-components';
import { RULER_HEIGHT } from '@src/constants/timeline';
import { COLOR } from '@src/styles/color';

export const StyledRuler = styled.div`
  position: relative;
  height: ${RULER_HEIGHT}px;
  width: 100%;
`;

// Labels sit centred on their tick, so half of each one hangs to the left of
// it. At second 0 that half lands on negative x — outside the scroll content —
// and the viewport's overflow clips it, leaving "0:00" shown as "):00". That one
// label is left-aligned instead, so it starts at the content edge and stays
// whole. (The right end needs no such case: CONTENT_END_PAD_PX already leaves
// room past the last tick.)
export const StyledTick = styled.span`
  position: absolute;
  top: 50%;
  transform: translate(
    ${({ align }) => (align === 'start' ? '0' : '-50%')},
    -50%
  );
  font-size: 12px;
  line-height: 16px;
  color: ${COLOR.darkV2[60]};
  white-space: nowrap;
  pointer-events: none;
`;

export const StyledMinorTick = styled.span`
  position: absolute;
  top: 50%;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: ${COLOR.darkV2[60]};
  pointer-events: none;
`;
